import { defineStore } from 'pinia'

export const useProgressStore = defineStore('progress', {
    state: () => ({
        duration: 0,
        episodes: []
    }),

    getters: {
        playedSeconds: (state) => {
            return state.episodes.reduce((acc, current) => {
                return acc + current.completed_seconds
            }, 0)
        },

        remainingSeconds: (state) => {
            return state.duration - state.playedSeconds
        },

        hasProgress: (state) => {
            return state.percentageProgress > 0
        },

        percentageProgress: (state) => {
            if (state.duration === 0) {
                return 0
            }

            return Math.floor((state.playedSeconds / state.duration) * 100)
        },

        episodeIsComplete: (state) => {
            return (id) => {
                return state.percentageProgressForEpisode(id) === 100
            }
        },

        percentageProgressForEpisode: (state) => {
            return (id) => {
                const episode = state.episodes.find(episode => episode.id === id)
                return Math.floor((episode?.completed_seconds / episode?.duration) * 100)
            }
        },
    },

    actions: {
        setDuration(duration) {
            this.duration = duration
        },

        setEpisodes(episodes) {
            this.episodes = episodes.map((episode) => {
                return {
                    id: episode.id,
                    duration: episode.duration_seconds,
                    completed_seconds: episode.user.completed_seconds
                }
            })
        }
    }
})
